import { ENTORNO } from "../utils/constantes";
import { getToken } from "../utils/variablesLocales";

export class apiEmail {
  baseApi = ENTORNO.BASE_API;

  async obtenerTodos() {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Email_Obtener}`;

      const parametros = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();

      if (respuesta.status !== 200) throw respuestaJson;

      return respuestaJson;
    } catch (error) {
      throw error;
    }
  }

  async actualizar(Id, Tipo, Idioma, Asunto, Texto, Activo) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Email_Actualizar}/${Id}`;

      const parametros = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          Tipo: Tipo,
          Idioma: Idioma,
          Asunto: Asunto,
          Texto: Texto,
          Activo: Activo,
        }),
      };

      const respuesta = await fetch(url, parametros);
      return respuesta;
    } catch (error) {
      throw error;
    }
  }

  async borrar(Id) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Email_Borrar}/${Id}`;

      const parametros = {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };

      const respuesta = await fetch(url, parametros);

      return respuesta;
    } catch (error) {
      throw error;
    }
  }

  enviar() {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Email_Enviar}`;

      const parametros = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          email: "jmrlacalera@gmail.com",
          Asunto: "Prueba",
          Cuerpo: "Prueba...",
          Idioma: "Español",
        }),
      };

      const respuesta = fetch(url, parametros);
      return respuesta;
    } catch (error) {
      throw error;
    }
  }

  enviar2(asunto, cuerpo) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Email_Enviar}`;

      const parametros = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          email: "jmrlacalera@gmail.com",
          Asunto: "Prueba",
          Cuerpo: "Prueba...",
          Idioma: "Español",
        }),
      };

      const respuesta = fetch(url, parametros);
      return respuesta;
    } catch (error) {
      throw error;
    }
  }
}
